import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { getAssistantSessionsContext } from '@/api/generated/assistant/assistant';
import { ROUTES, getAssistantSessionRoute } from '@/utils/routeUtils';
import { useAuthStore } from '@/utils/stores/useAuthStore';

interface UseSessionByContextParams {
  conversationId?: string;
  draftId?: string;
  emailId?: string;
}

export function useSessionByContext({
  conversationId,
  draftId,
  emailId,
}: UseSessionByContextParams) {
  const navigate = useNavigate();
  const { setLoading } = useAuthStore();

  return useQuery({
    enabled: !!emailId || !!draftId || !!conversationId,
    queryFn: async () => {
      setLoading(true);
      try {
        const response = await getAssistantSessionsContext({
          ...(emailId && { emailId }),
          ...(draftId && { draftId }),
          ...(conversationId && { conversationId }),
        });

        if (response?.sessionId) {
          navigate(getAssistantSessionRoute(response.sessionId), { replace: true });
        } else {
          navigate(ROUTES.ASSISTANT, { replace: true });
        }

        return response;
      } finally {
        setLoading(false);
      }
    },
    queryKey: ['session-by-context', emailId, draftId, conversationId],
    staleTime: 0,
  });
}
